import type { TrigKey } from './keys';

export const ru: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Математика · Тригонометрия',
  'panel.experiment': 'Эксперимент',
  'panel.params': 'Параметры',
  'panel.scene': 'Выберите эксперимент',
  'experiment.right-triangle.label': 'Прямоугольный треугольник',
  'experiment.unit-circle.label': 'Единичная окружность',
  'experiment.wave-studio.label': 'Студия волн',
  'experiment.identity-playground.label': 'Тождества',
  'experiment.triangle-solver.label': 'Решатель треугольников',
  'experiment.circular-polar.label': 'Круг и полярные',
  'hint.line1': 'Перетаскивайте точки и двигайте ползунки.',
  'hint.line2': 'Учебное содержание живёт в геометрии, а не в тексте.',
  'rt.angle.a': 'Угол A',
  'rt.angle.b': 'Угол B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Радианы',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tg',
  'rt.snap': 'Привязка к 30°/45°/60°',
  'uc.units': 'Единицы',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tg',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'ctg',
  'uc.show.astc': 'Показать ASTC',
  'uc.snap.common': 'Привязка к стандартным углам',
  'uc.angle.value': '∠',
  'uc.units.deg': 'град',
  'uc.units.rad': 'рад',
  'uc.units.both': 'град+рад',
  'ws.fn': 'Функция',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tg',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'ctg',
  'ws.amplitude': 'A — Амплитуда',
  'ws.frequency': 'B — Частота',
  'ws.phase': 'C — Сдвиг фазы',
  'ws.shift': 'D — Вертикальный сдвиг',
  'ws.rform.toggle': 'Вывод R-формы',
  'ws.rform.a': 'a (коэф. sin)',
  'ws.rform.b': 'b (коэф. cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Сброс',
  'ws.base': 'Показать базовую кривую',
  'ip.id.pythagorean': 'Пифагорово',
  'ip.id.reciprocal': 'Обратное',
  'ip.id.quotient': 'Частного',
  'ip.id.sum': 'Суммы',
  'ip.id.difference': 'Разности',
  'ip.id.double': 'Двойного угла',
  'ip.id.half': 'Половинного угла',
  'ip.play': 'Воспроизвести',
  'ip.pause': 'Пауза',
  'ip.step': 'Шаг',
  'ip.reset': 'Сброс',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  ctg θ = 1/tg θ',
  'ip.proof.quotient.summary': 'tg θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'В v2 — для доказательства нужна более развитая конструкция.',
  'ts.area': 'Площадь',
  'ts.sineRule': 'Теорема синусов',
  'ts.cosineRule': 'Теорема косинусов',
  'ts.ambiguous.toggle': 'Призрак при неоднозначности',
  'ts.reset': 'Сброс к равностороннему',
  'ts.snap.integers': 'Привязка к целым',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Стороны',
  'ts.section.angles': 'Углы',
  'ts.section.sineRule': 'Теорема синусов',
  'ts.section.cosineRule': 'Теорема косинусов',
  'ts.section.area': 'Площадь',
  'cp.omega': 'Угловая скорость',
  'cp.plot.y': 'График y (sin)',
  'cp.plot.x': 'График x (cos)',
  'cp.polar.label': 'Полярная фигура',
  'cp.polar.circle': 'Окружность (r = 1)',
  'cp.polar.rose': 'Роза (r = sin 3θ)',
  'cp.polar.cardioid': 'Кардиоида (r = 1 + cos θ)',
  'cp.polar.limacon': 'Лимасон (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Малые углы (sin x ≈ x)',
  'cp.play': 'Воспроизвести',
  'cp.pause': 'Пауза',
  'cp.reset': 'Сброс',
  'cp.step': 'Шаг π/12',
};
